import getConfig from 'next/config';

import type { AntiFraudSession } from '@sravni/mpl-antifraud/lib/types/antiFraudSession';

import { AntiFraudReadCookies } from './AntiFraudReadCookies';
import { FHPScript } from './FHPScript';
// import { SFDScript } from './SFDScript';

interface IAntiFraudProps {
  session?: AntiFraudSession;
}

export const AntiFraud = ({ session }: IAntiFraudProps) => (
  <>
    <AntiFraudReadCookies />
    {getConfig().publicRuntimeConfig.antiFraudFhp && <FHPScript sessionId={session?.id} />}
    {/*{getConfig().publicRuntimeConfig.antiFraudSfd && <SFDScript />}*/}
  </>
);
